export default "__VITE_ASSET__C73wIJ$W__"